<template>
  <section>
    <h5>{{ $t('DASHBOARD.LATEST_TEAM_DOCUMENTS')}}</h5>
    <b-card no-body>
      
      <ledger-item v-for="item in items" :item="item" :small="1" :key="item.document.id"></ledger-item>

      <b-card-body
        class="text-center"
        v-if="items.length == 0"
      >{{ $t('DASHBOARD.NO_TEAM_DOCUMENTS')}}</b-card-body>

      <b-card-footer class="clickable text-center">
        <router-link :to="{ name: 'Documents.Team' }">
          <i class="fal fa-file-edit" />
          {{$t('DASHBOARD.GOTO_TEAM_DOCUMENTS')}}
        </router-link>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
import LedgerItem from "@/components/Ledger/LedgerItem";
export default {
  components: {
    LedgerItem
  },
  data() {
    return {
      page: 0,
      limit: 3,
      items: [],
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getPublished: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/team/list", {
          page: this.page,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getPublished();
  }
};
</script>
<style>
</style>
